import { render, staticRenderFns } from "./ProductProviderList.vue?vue&type=template&id=51aa94a2"
import script from "./ProductProviderList.vue?vue&type=script&lang=js"
export * from "./ProductProviderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports